import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Dropzone from 'react-dropzone';
import { Grid, Button } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import AddIcon from '@material-ui/icons/Add';

import BDE from '../../utils/api-controllers/bde/BDE';
import AWS from '../../utils/api-controllers/aws/AWS';
import { styles } from './styles';

class UploadComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onSubmit(file) {
    let data = this.props.uploadObj;
    data['file'] = file[0];
    if (this.props.uploadToS3) {
      AWS.uploadToS3(
        data['file'],
        file[0].name,
        this.props.bucketName,
        this.props.successCallback,
        this.props.failureCallback,
      );
    } else {
      if(this.props.event_id) data['event_id'] = this.props.event_id;
      BDE.uploadFile(
        data,
        this.props.successCallback,
        this.props.failureCallback,
      );
    }
  }

  render() {
    const classes = this.props.classes;
    return (
      <Grid className={classes.flex}>
        <Dropzone
          onDrop={this.onSubmit.bind(this)}
          accept={this.props.accept ? this.props.accept : '.csv'}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} disabled={this.props.isDisabled} />
                {this.props.type == 'event_level' ? (
                  <div className={classes.eventContainer}>
                    <AddIcon className={classes.addIcon}></AddIcon>
                    <div className={classes.event}>{this.props.content}</div>
                  </div>
                ) : (
                  <Button
                    className={classes.button}
                    color="primary"
                    type="button"
                    variant="contained"
                    disabled={this.props.isDisabled}
                  >
                    <PublishIcon className={classes.filterIcon} />
                    Upload {this.props.upload_type_name}
                  </Button>
                )}
              </div>
            </section>
          )}
        </Dropzone>
      </Grid>
    );
  }
}

export default withStyles(styles)(UploadComponent);
